import React, { PropTypes } from "react";
import {
  ControlLabel,
  FormControl,
  FormGroup,
  HelpBlock,
} from "react-bootstrap";
import VirtualizedSelect from "react-virtualized-select";
import { FormattedMessage, intlShape } from "react-intl";
import _ from "lodash";

class NewSelectInput extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      sortedOptions: [],
      needsResize: true,
      selectWidth: 0,
    };
  }

  componentWillMount() {
    this.updateSelectInput(this.props);
  }

  componentDidMount() {
    this._updateSelectWidth();
  }

  componentWillReceiveProps(nextProps) {
    if (!_.isEqual(nextProps.options, this.props.options)) {
      this.setState({
        needsResize: true,
      });
    }
    this.updateSelectInput(nextProps);
  }

  componentDidUpdate() {
    this._updateSelectWidth();
  }

  updateSelectInput(props) {
    const {
      addBlankOption,
      blankMessageKey,
      blankOptionValue,
      noOptionsAction,
      options,
      sortOptions,
    } = props;

    const formattedOptions = options.map((option) => {
      const text =
        option.text ||
        this.context.intl.formatMessage(
          { id: option.key },
          option.placeHolders
        );
      const optionValue =
        typeof option.value == "boolean"
          ? option.value
          : option.value.toString();
      return {
        value: optionValue,
        selected: option.value === props.input.value,
        text,
      };
    });

    let sortedOptions = sortOptions
      ? formattedOptions.sort((a, b) => {
          return a.text.localeCompare(b.text);
        })
      : formattedOptions;
    const blankKey = blankMessageKey || "common.blank";

    if (addBlankOption && blankMessageKey) {
      addBlankOption &&
        sortedOptions.unshift({
          value: blankOptionValue,
          text: this.context.intl.formatMessage({ id: blankKey }),
        });
    }

    this.setState({ sortedOptions });

    const emptyLength = addBlankOption ? 1 : 0;
    if (sortedOptions.length === emptyLength && noOptionsAction) {
      noOptionsAction();
    }
  }

  _updateSelectWidth() {
    if (this.state.needsResize && this.state.sortedOptions.length) {
      const selectSizer = document.createElement("select");
      const largestInput = _.maxBy(
        this.state.sortedOptions,
        (option) => option.text.length
      );
      const option = document.createElement("option");
      option.innerText = !!largestInput ? largestInput.text : " ";
      selectSizer.appendChild(option);

      selectSizer.style.position = "absolute";
      selectSizer.style.top = "-99999px";
      selectSizer.style.boxSizing = "border-box";

      document.body.appendChild(selectSizer);

      this.setState({
        needsResize: false,
        selectWidth: selectSizer.clientWidth,
      });

      document.body.removeChild(selectSizer);
    }
  }

  render() {
    const {
      addBlankOption,
      disabled,
      groupClassName,
      id,
      input,
      label,
      loading,
      meta: { touched, error },
      multi,
      onChange,
      onFocus,
      onBlur,
      options,
      required,
    } = this.props;

    const scene = this.context.scene ? "-" + this.context.scene : "";
    const validationState = touched && !!error ? error.state : null;
    const validationMessageKey =
      !!error && error.messageKey ? error.messageKey : null;
    const validationValues = !!error && error.values ? error.values : null;

    let cleanValue = input.value;
    if (
      (addBlankOption && input.value === null) ||
      input.value === undefined ||
      input.value === ""
    ) {
      cleanValue = " ";
    }
    const processedInput = { ...input, value: `${cleanValue}` };

    const placeholder = this.context.intl.formatMessage({
      id: "common.select",
    });
    const searchable = this.props.searchable || false;

    return (
      <FormGroup
        className={groupClassName}
        controlId={id + scene}
        validationState={validationState}
      >
        {!!label && (
          <ControlLabel>
            {label} {required ? <span className="required"> *</span> : ""}
          </ControlLabel>
        )}
        <div className="input-wrapper">
          <FormControl
            {...processedInput}
            componentClass={VirtualizedSelect}
            multi={multi}
            disabled={options.length === 0 || disabled || loading}
            onFocus={() => {
              onFocus && onFocus();
              return input.onFocus();
            }}
            onChange={(selection) => {
              const value = multi ? selection : selection.value;

              const emulatedEvent = {
                target: {
                  value,
                  name: input.name,
                },
              };
              onChange && onChange(emulatedEvent);

              if (multi) {
                return input.onChange(value.map((v) => v.value).join(","));
              }

              //fix redux bug when value is false
              if (value === false) {
                input.value = false;
                input.onBlur(input.value);
              }

              return input.onChange(value);
            }}
            onBlur={() => {
              onBlur && onBlur(input.value);
              return input.onBlur(input.value);
            }}
            autosize={true}
            searchable={searchable}
            resetValue={{ value: " " }}
            clearable={searchable}
            labelKey="text"
            valueKey="value"
            placeholder={placeholder}
            options={this.state.sortedOptions}
            style={{ minWidth: this.state.selectWidth }}
          />
          {touched && error && (
            <HelpBlock>
              <FormattedMessage
                id={validationMessageKey}
                values={validationValues}
              />
            </HelpBlock>
          )}
        </div>
      </FormGroup>
    );
  }
}

NewSelectInput.propTypes = {
  disabled: PropTypes.bool,
  groupClassName: PropTypes.string,
  id: PropTypes.string.isRequired,
  input: PropTypes.object.isRequired,
  label: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  meta: PropTypes.object.isRequired,
  multi: PropTypes.bool,
  noOptionsAction: PropTypes.func,
  options: PropTypes.array.isRequired,
  sortOptions: PropTypes.bool,
  validation: PropTypes.object,
  validationKey: PropTypes.string,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  blankMessageKey: PropTypes.string,
  addBlankOption: PropTypes.bool,
  blankOptionValue: PropTypes.string,
  loading: PropTypes.bool,
  required: PropTypes.bool,
  searchable: PropTypes.bool,
};

NewSelectInput.defaultProps = {
  blankOptionValue: " ",
  loading: false,
  multi: false,
  sortOptions: true,
};

NewSelectInput.contextTypes = {
  scene: PropTypes.string,
  intl: intlShape,
};

export default NewSelectInput;



// WEBPACK FOOTER //
// ./src/components/common/form/NewSelectInput.js